const prescription = (startDay, isAstop) => {
  const startDayArray = [];
  for (let i = 0; i < 7; i++) {
    if (startDay + i < 7) {
      startDayArray.push(startDay + i);
    } else {
      startDayArray.push(startDay + i - 7);
    }
  }
  const newArr = [];
  for (let i = 0; i < 12; i++) {
    const newObj = {};
    const treatmentList = [];
    if (isAstop) {
      for (let j = 0; j < 7; j++) {
        const treatment = {};
        treatment.dayNum = startDayArray[j];
        treatment.id = "";
        treatment.preLearningWeekNum = "";
        treatment.preLearningDayNum = "";
        treatment.categoryName = "";
        treatment.name = "";
        treatmentList.push(treatment);
      }
      newObj.weekNum = i + 1;
      newObj.treatmentList = treatmentList;
      newArr.push(newObj);
    } else {
      for (let j = 0; j < 5; j++) {
        const treatment = {};
        treatment.dayNum = startDayArray[j];
        treatment.id = "";
        treatment.preLearningWeekNum = "";
        treatment.preLearningDayNum = "";
        treatment.categoryName = "";
        treatment.name = "";
        treatmentList.push(treatment);
      }
      newObj.weekNum = i + 1;
      newObj.treatmentList = treatmentList;
      newArr.push(newObj);
    }
  }
  return newArr;
};

export default prescription;
